import { useState } from 'react';
import { topicWall } from '@/mocks/home';

const palette = [
  'bg-primary-100 text-primary-800 border-primary-200 hover:bg-primary-200',
  'bg-accent-100 text-accent-900 border-accent-200 hover:bg-accent-200',
  'bg-secondary-100 text-secondary-900 border-secondary-200 hover:bg-secondary-200',
  'bg-background-100 text-foreground-700 border-background-300 hover:bg-background-200',
];

const sizeClass: Record<string, string> = {
  sm: 'text-xs px-3 py-1.5',
  md: 'text-sm px-4 py-2',
  lg: 'text-base px-5 py-2.5 font-medium',
};

export default function TopicWall() {
  const [active, setActive] = useState('深夜电台');

  return (
    <section id="topics" className="bg-background-50">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="text-xs font-label font-medium text-accent-700 tracking-wide mb-2">
              话题墙
            </p>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
              从一个话题切进去
            </h2>
            <p className="mt-3 text-sm font-label text-foreground-600 leading-relaxed">
              话题墙把 36 个内容分类平铺摊开，挑一个顺眼的点进去，相关的主播、短视频与合集都会跟着露出来。
            </p>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-4">
              <p className="text-xs font-label text-foreground-500">当前选中话题</p>
              <p className="mt-1 font-heading text-xl font-black text-foreground-950">{active}</p>
              <p className="mt-1 text-xs font-label text-foreground-600">
                该话题下已收录 126 条内容 · 8 位主播
              </p>
              <a
                href="#hot"
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-label font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看该话题热门
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-wrap gap-2 md:gap-2.5 content-start">
              {topicWall.map((topic, index) => {
                const isActive = topic.label === active;
                const colorClass = isActive
                  ? 'bg-foreground-950 text-background-50 border-foreground-950 hover:bg-foreground-800'
                  : palette[index % palette.length];
                return (
                  <button
                    key={topic.label}
                    type="button"
                    onClick={() => setActive(topic.label)}
                    className={[
                      'rounded-full border font-label transition-colors cursor-pointer whitespace-nowrap',
                      sizeClass[topic.size] ?? sizeClass.md,
                      colorClass,
                    ].join(' ')}
                  >
                    #{topic.label}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}